import { createSlice } from "@reduxjs/toolkit";

const filesStatusesSlice = createSlice({
  name: "filesStatuses",
  initialState: {},
  reducers: {
    setFilesStatusesData: (_state, action) =>
      action.payload.reduce((prev, curr) => {
        if (curr.name.toLowerCase() == "deleted") {
          return prev;
        }
        return { ...prev, [curr.id]: curr };
      }, {}),
  },
});

const currentPathSlice = createSlice({
  name: "currentPath",
  initialState: null,
  reducers: {
    setCurrentPath: (_state, action) => action.payload,
  },
});

export const { setFilesStatusesData } = filesStatusesSlice.actions;
export const { setCurrentPath } = currentPathSlice.actions;

export const filesStatuses = filesStatusesSlice.reducer;
export const currentPath = currentPathSlice.reducer;

export default filesStatusesSlice.reducer;
